import { useQuery } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { urlWithParams } from '../../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';
import { useTransferMoneyContext } from '../hooks/useTransferMoneyContext';

export enum DepositFrequencyType {
  OneTime,
  Weekly,
  EveryOtherWeek,
  TwiceAMonth,
  Monthly,
  Quarterly,
}

export type ContributionYearsOptionsDTO = number[];

export interface ContributionTypesOptionsDTO {
  label: string;
  value: number;
  contributionYears: ContributionYearsOptionsDTO;
}

export interface AchFundingOptionsDTO {
  contributionTypes: ContributionTypesOptionsDTO[];
  isIraAccount: boolean;
  fundingFrequencyTypes: FundingFrequencyTypesOptionsDTO[];
}

export interface FundingFrequencyTypesOptionsDTO {
  label: string;
  value: DepositFrequencyType;
  showFirstRecurringDepositDay: boolean;
  showSecondRecurringDepositDay: boolean;
}

const fetchAchFundingOptions = (
  clientId: string,
  managedAccountId: string | null,
): Promise<AchFundingOptionsDTO> => {
  return authFetch(
    urlWithParams('/Consumer/AchTransfers/FundingOptions', {
      clientId,
      managedAccountId,
    }),
  );
};

export const useAchFundingOptionsQuery = () => {
  const { clientId, managedAccountId } = useTransferMoneyContext();

  return useQuery(queryKeys.fundingOptions(clientId, managedAccountId), () =>
    fetchAchFundingOptions(clientId, managedAccountId),
  );
};
